module.exports = __webpack_public_path__ + "img/twitter.06c7d15a.svg";